import request from '@/utils/request'

export default {
  // 审批列表
  postApproveDrugBookList(data) {
    return request({
      url: `/emi/approve/drugBookList`,
      method: 'POST',
      data
    })
  },
  // 电子说明书审批详情,待审批状态调这个接口
  getDrugBookDetailForAudit(data) {
    return request({
      url: `/emi/approve/drugBookDetailForAudit`,
      method: 'POST',
      data
    })
  },
  // 电子说明书审批详情,审批完成状态调这个接口
  getDrugBookDetail(data) {
    return request({
      url: `/emi/approve/drugBookDetail`,
      method: 'POST',
      data
    })
  },
  // 审批
  approveAudit(data) {
    return request({
      url: `/emi/approve/audit`,
      method: 'POST',
      data
    })
  },
  // 审批审批流程日志
  getApproveLogList(data) {
    return request({
      url: `/emi/approve/logList`,
      method: 'POST',
      data
    })
  },
  // 根据审批编码获取审批日志
  getApproveLogListForAuditCode(data) {
    return request({
      url: `/emi/approve/approveLogList`,
      method: 'POST',
      data
    })
  }

}
